/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PseudonymAppointmentsStep_3Aliases {
  CHECKBOX_SAVE = 'checkbox-save',
  FETCH_ADDITIONAL_INFORMATION = 'fetch-additional-information',
  FIELD_CHECKBOX_SAVE = 'field-checkbox-save',
  FORM_ADDITIONAL_INFORMATION = 'form-additional-information',
  HEIGHT_FIELD = 'height-field',
  HEIGHT_INPUT = 'height-input',
  LAYOUT_ADDITIONAL_INFORMATION = 'layout-additional-information',
  PANEL_ADDITIONAL_INFORMATION = 'panel-additional-information',
  TEXT_ADDITIONAL_INFORMATION_INSTRUCTION = 'text-additional-information-instruction',
  WEIGHT_FIELD = 'weight-field',
  WEIGHT_INPUT = 'weight-input',
}
export { PseudonymAppointmentsStep_3Aliases };
